import RegistroCreate from './RegistroCreate'
import RegistroConfirm from './RegistroConfirm'

export const registroRoutes = [
  { name: 'registro-create', path: '/criar-conta', component: RegistroCreate },
  {
    name: 'registro-confirm',
    path: '/confirmar-conta',
    component: RegistroConfirm
  }
]
